import { datadogRum } from '@datadog/browser-rum';

import { DomainAction } from '../domain/action';
import { DomainError } from '../domain/error';
import { AuthUser } from '../ports/auth';
import { Monitor } from '../ports/monitor';
import {
    DATADOG_APPLICATION_ID,
    DATADOG_CLIENT_TOKEN,
    RELEASE_VERSION,
    ENVIRONMENT,
    DATADOG_SITE,
    DATADOG_APPLICATION_NAME,
} from '../variables';

export class EcopilotMonitor implements Monitor {
    constructor() {
        datadogRum.init({
            applicationId: DATADOG_APPLICATION_ID,
            clientToken: DATADOG_CLIENT_TOKEN,
            site: DATADOG_SITE,
            service: DATADOG_APPLICATION_NAME,
            env: ENVIRONMENT,
            version: RELEASE_VERSION,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask',
        });

        datadogRum.startSessionReplayRecording();
    }

    setUser(user: AuthUser): void {
        datadogRum.setUser({ id: user.url });
        datadogRum.setUserProperty('type', user.type);
        datadogRum.setUserProperty('profileId', user.id);
    }

    action<T extends DomainAction>(action: T): void {
        datadogRum.addAction(action.type, action.context);
    }

    error<T extends DomainError>(error: T): void {
        datadogRum.addError(error);
    }
}
